<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Experiências</v-toolbar-title>
        <v-spacer></v-spacer>
        <small class="mr-4 text-right">Última atualização:<br/>18/08/2025</small>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn @click="detailsModal = item.gateway_id" color="primary" fab text small dark>
            <v-icon>mdi-piggy-bank-outline</v-icon>
          </v-btn>
          <v-btn @click="transactionsModal = item.gateway_id" color="primary" fab text small dark>
            <v-icon>mdi-transfer</v-icon>
          </v-btn>
          <v-btn :href="'https://experiencia.heppi.io/organizacao/experiencia/' + item.id" target="_blank" color="primary" fab text small dark>
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.started_at="{ item }">
          {{ item.started_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
        <template v-slot:item.finished_at="{ item }">
          {{ item.finished_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    </v-container>
    <account-modal :accountId="detailsModal" @close="detailsModal = null"></account-modal>
    <v-dialog :value="!!transactionsModal" @click:outside="transactionsModal = null" max-width="90%">
      <v-card>
        <v-card-title>
          <div class="row align-center pa-0">
            <div class="col headline">Movimentações</div>
            <div class="col-auto pa-sm">
              <v-btn fab text color="default" @click="transactionsModal = null">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="pt-3 pb-6">
          <v-tabs
            center-active
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-withdraws" href="#tab-withdraws">Saques</v-tab>
            <v-tab key="tab-transfers" href="#tab-transfers">Pagto Fornecedor</v-tab>
            <v-tab-item key="tab-item-withdraws" value="tab-withdraws">
              <account-withdraws :accountId="transactionsModal"></account-withdraws>
            </v-tab-item>
            <v-tab-item key="tab-item-transfers" value="tab-transfers">
              <account-transfers :accountId="transactionsModal"></account-transfers>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import data from './experiencias-suporte.json'
import Quicksearch from '@/components/Quicksearch'
import AccountModal from '@/components/AccountModal'
import AccountTransfers from '@/components/AccountTransfers'
import AccountWithdraws from '@/components/AccountWithdraws.vue'

export default {
  name: 'experiences',
  components: {
    Quicksearch,
    AccountModal,
    AccountTransfers,
    AccountWithdraws
  },
  data: () => ({
    loading: false,
    quicksearch: '',
    detailsModal: null,
    transactionsModal: null,
    items: [],
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Nome',
        value: 'name'
      },
      {
        text: 'Local',
        sortable: false,
        value: 'location'
      },
      {
        text: 'Início',
        sortable: false,
        value: 'started_at'
      },
      {
        text: 'Término',
        sortable: false,
        value: 'finished_at'
      }
    ],
    pagination: {
      rowsPerPage: 20,
      page: 1,
      total: 0,
      sortBy: [],
      sortDesc: []
    }
  }),
  computed: {
    noResultText () {
      return 'Nenhuma experiencia encontrada'
    },
    filteredItems () {
      return this.items.filter(e => !this.quicksearch || e.name.toLowerCase().search(this.quicksearch) >= 0)
    }
  },
  methods: {
    getData () {
      if (data && data.length > 0) {
        console.log(data)
        this.items = [...data]
      } else {
        setTimeout(() => { this.getData() }, 1000)
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>
